'use client'

import { Button } from '@/components/ui/button'

export const ScrollToCollectionButton = ({
  children,
}: {
  children: React.ReactNode
}) => {
  return (
    <Button
      variant='black'
      onClick={() => {
        document.getElementById('collection-listing')?.scrollIntoView({
          behavior: 'smooth',
        })
      }}
    >
      {children}
    </Button>
  )
}
